var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":_vm.src}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }